module.exports = __webpack_public_path__ + "img/9-23.388be34b.jpg";